import RulesPage from "./components/Rules";


function App() {
  return (
    <RulesPage />
  );
}

export default App;
